import React from "react";
import { ShieldCheck, Activity, Briefcase, DatabaseBackup } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const operatingPillars = [{
  title: "Unwavering Integrity",
  description: "Our practice is built on the bedrock of ethical excellence. We provide transparent counsel and steadfast representation, ensuring your legal standing is never compromised.",
  icon: ShieldCheck,
  number: "01"
}, {
  title: "Proven Results",
  description: "We measure our success by the tangible outcomes we secure for our clients. Our strategic approach is designed to deliver high-impact resolutions in complex legal matters.",
  icon: Activity,
  number: "02"
}, {
  title: "Absolute Confidentiality",
  description: "Discretion is the hallmark of Sterling Law. We maintain the highest standards of privacy, protecting your sensitive information with architectural-grade security protocols.",
  icon: Briefcase,
  number: "03"
}, {
  title: "Strategic Foresight",
  description: "We anticipate legal challenges before they arise. Our proactive methodology ensures that your interests are protected against future volatility and unforeseen risks.",
  icon: DatabaseBackup,
  number: "04"
}];
export default function CoreValues() {
  return <section data-section-id="261084" id="core-values" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold font-default text-primary mb-4 tracking-tight">
            The Sterling Standard
          </h2>
          <p className="text-lg text-muted-foreground font-sans">
            Our firm operates on a foundation of intellectual depth and architectural precision, ensuring every client receives elite representation tailored to their unique legal landscape.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {operatingPillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <Card key={i} data-index={i} className="relative overflow-hidden border-border/40 bg-background/5 backdrop-blur-sm shadow-md hover:shadow-lg transition-all duration-500 group">
                {}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5 select-none">
                  <span className="text-9xl font-serif font-bold text-secondary">
                    {pillar.number}
                  </span>
                </div>
                
                <CardHeader className="relative z-10 flex flex-row items-start gap-4 pb-2">
                  <div className="bg-primary/5 p-3 rounded-md shrink-0 border border-primary/20">
                    <Icon className="w-6 h-6 text-primary" aria-hidden="true" />
                  </div>
                  <div>
                    <CardTitle className="text-xl font-default text-foreground leading-tight group-hover:text-primary transition-colors duration-300">
                      {pillar.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="relative z-10">
                  <p className="text-muted-foreground leading-relaxed font-sans">
                    {pillar.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}